import css from './index.module.scss';
import RetailStorePanel from './RetailStorePanel';
import BrandLists from './BrandLists';
import PRHIVK from './PRHIVK';
import { useGlobal } from '@/utils/useGlobal';

export default function WhereToBuyPC() {
    const { useLang, useRouter, useState, gtm } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();
    const [active, setActive] = useState(['us', 'ca'].includes(locale) ? 'certified_dealer' : 'retail');

    const onClickTab = (tab: string, tabText: string) => {
        active !== tab && setActive(tab);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: tabText,
        });
    };

    return (
        <div className={`whereToBuy_pc ${css.whereToBuy_pc}`}>
            <h1 className="title">{t('title')}</h1>
            <div className="subTitle">{t('subTitle')}</div>
            <div className="tabsContainer">
                {['us', 'cn', 'ca'].includes(locale) && (
                    <div className="tabs">
                        {['us', 'ca'].includes(locale) && (
                            <li
                                className={`${active === 'certified_dealer' ? 'active' : ''} tab_item`}
                                onClick={() => onClickTab('certified_dealer', t('tab_certified_dealer'))}
                            >
                                <span className="text">{t('tab_certified_dealer')}</span>
                            </li>
                        )}
                        {['us', 'cn', 'ca'].includes(locale) && (
                            <li className={`${active === 'retail' ? 'active' : ''} tab_item`} onClick={() => onClickTab('retail', t('tab_retailStore'))}>
                                <span className="text">{t('tab_retailStore')}</span>
                            </li>
                        )}
                        {['us', 'cn', 'ca'].includes(locale) && (
                            <li
                                className={`${active === 'offcial' ? 'active' : ''} tab_item`}
                                onClick={() => onClickTab('offcial', t('tab_offcialOnlineStores'))}
                            >
                                <span className="text">{t('tab_offcialOnlineStores')}</span>
                            </li>
                        )}
                        {['us', 'ca'].includes(locale) && (
                            <li className={`${active === 'PR_HI_VK' ? 'active' : ''} tab_item`} onClick={() => onClickTab('PR_HI_VK', t('tab_PR_HI_VK'))}>
                                <span className="text">{t('tab_PR_HI_VK')}</span>
                            </li>
                        )}
                    </div>
                )}
                {['us', 'ca'].includes(locale) && <RetailStorePanel visible={active === 'certified_dealer'} typeCode={'2'} />}
                {['us', 'ca'].includes(locale) ? (
                    <RetailStorePanel visible={active === 'retail'} typeCode={'1'} />
                ) : (
                    <RetailStorePanel visible={active === 'retail'} />
                )}
                <div className={`offcailOnlineStores ${active === 'offcial' ? 'active' : ''}`}>
                    <BrandLists />
                </div>
                <div className={`PRHIVK ${active === 'PR_HI_VK' ? 'active' : ''}`}>
                    <PRHIVK />
                </div>
            </div>
            <style jsx global>
                {`
                    #allContentContainer {
                        overflow: auto;
                    }
                `}
            </style>
        </div>
    );
}
